import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';

export default (appName: string, env: string): string => {
    let versionText = `${appName} version: `;
    const { VITE_APP_VERSION, VITE_GIT_COMMIT_HASH, VITE_GIT_COMMIT_DATE, VITE_GIT_BRANCH } = (
        import.meta as any
    ).env;

    const version = VITE_APP_VERSION || '';
    const commitHash = VITE_GIT_COMMIT_HASH || '';
    const commitDate = ['dev', 'staging'].includes(env) ? VITE_GIT_COMMIT_DATE || '' : '';
    const branch = env === 'staging' ? VITE_GIT_BRANCH + ' ' : '';

    versionText += version;

    if (commitHash) {
        versionText += ` (${branch}${commitHash}`;
        if (commitDate) {
            const date = new TZDate(commitDate, 'UTC');
            const formattedDate = format(date, "dd MMM HH:mm 'UTC'");
            versionText += `, ${formattedDate}`;
        }
        versionText += ')';
    }

    return versionText;
};
